export default [    //围栏
  {
    path: "/fencelist",
    name: 'fencelist',
    component: () => import("@/views/fence/fencelist.vue")
  },
  {
    path: "/fenceDetail",
    name: 'fenceDetail',
    component: () => import("@/views/fence/fenceDetail.vue")
  },
  {
    path: "/fenceEdit",
    name: 'fenceEdit',
    component: () => import("@/views/fence/fenceEdit.vue")
  },
  {
    path: "/fenceAdministrator",
    name: 'fenceAdministrator',
    component: () => import("@/views/fence/fenceAdministrator.vue")
  },
  {
    path: "/fenceMembers",
    name: 'fenceMembers',
    component: () => import("@/views/fence/fenceMembers.vue")
  },
  {
    path: "/fenceMyMembersList",
    name: 'fenceMyMembersList',
    component: () => import("@/views/fence/fenceMyMembersList.vue")
  },
  {
    path: "/fencerecord",
    name: 'fencerecord',
    component: () => import("@/views/fencerecord/fenceRecordList.vue")
  }
]
